// اقلام رسیدگی (انواع رسیدگی + اقلام هر نوع)
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePager, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

const API = (path, opts = {}) => fetch(`/api/evaluation${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

const EMPTY = () => ({ title: '', remark: '' });
const EMPTY_DETAIL = () => ({ title: '', remark: '', begin_date: '', end_date: '', level: 0 });

/* مودال اقلام یک نوع رسیدگی */
function DetailsModal({ ev, onClose, onChanged }) {
  // دکمه‌های فرم FRMEVALUATIONDETAIL — دیدن = دسترسی
  const vbf = useFormButtons('FRMEVALUATIONDETAIL', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK"]);
  const [rows, setRows]   = useState([]);
  const [levels, setLevels] = useState([]);
  const [sel, setSel]     = useState(null);
  const [mode, setMode]   = useState(null);
  const [form, setForm]   = useState(EMPTY_DETAIL());
  const [err, setErr]     = useState('');
  const [busy, setBusy]   = useState(false);

  const load = useCallback(async () => {
    const j = await API(`/items/${ev.id}/details/`);
    if (j.ok) { setRows(j.data); setLevels(j.levels || []); setSel(null); } else setErr(j.msg);
  }, [ev.id]);
  useEffect(() => { load(); }, [load]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    setBusy(true); setErr('');
    const body = JSON.stringify(form);
    const j = mode === 'new'
      ? await API(`/items/${ev.id}/details/create/`, { method: 'POST', body })
      : await API(`/items/${ev.id}/details/${sel.id}/update/`, { method: 'PUT', body });
    setBusy(false);
    if (j.ok) { setMode(null); load(); onChanged?.(); } else setErr(j.msg);
  };

  const del = async () => {
    if (!sel) return;
    setBusy(true); setErr('');
    const j = await API(`/items/${ev.id}/details/${sel.id}/delete/`, { method: 'DELETE' });
    setBusy(false);
    if (j.ok) { load(); onChanged?.(); } else setErr(j.msg);
  };

  return (
    <div style={ui.overlay} onClick={onClose}>
      <div style={{ ...ui.modal, maxWidth: '860px' }} onClick={e => e.stopPropagation()}>
        <div style={ui.mHeader}>
          <div style={ui.mTitle}>⭐ اقلام رسیدگی — {ev.title}</div>
          <button onClick={onClose} style={ui.closeBtn}>✕</button>
        </div>
        <div style={ui.mBody}>
          {err && <div style={ui.errBox}>⚠️ {err}</div>}
          <div style={{ ...ui.toolBtns, marginBottom: '8px' }}>
            {vbf.can('BTNNEW') && <button onClick={() => { setForm(EMPTY_DETAIL()); setErr(''); setMode('new'); }} style={ui.btnNew}>＋ جدید</button>}
            {vbf.can('BTNEDIT') && <button onClick={() => { if (!sel) return; setForm({ title: sel.title, remark: sel.remark, begin_date: sel.begin_date, end_date: sel.end_date, level: sel.level }); setErr(''); setMode('edit'); }}
              disabled={!sel} style={{ ...ui.btnEdit, opacity: sel ? 1 : 0.4 }}>✎ ویرایش</button>}
            {vbf.can('BTNDELETE') && <button onClick={del} disabled={!sel || busy} style={{ ...ui.btnDel, opacity: sel ? 1 : 0.4 }}>✕ حذف</button>}
          </div>

          {mode && (
            <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '10px', marginBottom: '10px' }}>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 2 }}>
                  <label style={ui.mlabel}>عنوان</label>
                  <input value={form.title} onChange={e => F('title', e.target.value)} style={ui.input} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>سطح رسیدگی</label>
                  <select value={form.level} onChange={e => F('level', Number(e.target.value))} style={ui.input}>
                    {levels.map((l, i) => <option key={i} value={i}>{l}</option>)}
                  </select>
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>از تاریخ</label>
                  <JalaliDatePicker value={form.begin_date} onChange={v => F('begin_date', v)} placeholder="از تاریخ" />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>تا تاریخ</label>
                  <JalaliDatePicker value={form.end_date} onChange={v => F('end_date', v)} placeholder="تا تاریخ" />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>توضیحات</label>
                  <input value={form.remark} onChange={e => F('remark', e.target.value)} style={ui.input} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '8px' }}>
                <button onClick={() => { setMode(null); setErr(''); }} style={ui.btnCancel}>انصراف</button>
                {vbf.can('BTNOK') && <button onClick={save} disabled={busy} style={ui.btnSave}>{busy ? '⏳ ...' : '💾 ذخیره'}</button>}
              </div>
            </div>
          )}

          <table style={ui.table}>
            <thead><tr>
              <th style={ui.th}>سطح رسیدگی</th><th style={ui.th}>عنوان</th>
              <th style={ui.th}>از تاریخ</th><th style={ui.th}>تا تاریخ</th><th style={ui.th}>توضیحات</th>
            </tr></thead>
            <tbody>
              {rows.map((r, i) => {
                const s2 = sel?.id === r.id;
                return (
                  <tr key={r.id} onClick={() => setSel(s2 ? null : r)}
                    style={{ background: s2 ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf3e3', color: s2 ? '#fff' : '#111', cursor: 'pointer' }}>
                    <td style={{ ...ui.td, textAlign: 'right', color: 'inherit' }}>{r.level_name}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: 'inherit' }}>{r.title}</td>
                    <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: 'inherit' }}>{r.begin_date || '•'}</td>
                    <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: 'inherit' }}>{r.end_date || '•'}</td>
                    <td style={{ ...ui.td, textAlign: 'right', color: 'inherit' }}>{r.remark || '•'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {rows.length === 0 && <div style={ui.empty}>قلمی ثبت نشده است</div>}
        </div>
        <div style={ui.mFooter}><button onClick={onClose} style={ui.btnCancel}>بستن</button></div>
      </div>
    </div>
  );
}

export default function EvaluationItemList({ user, onBack }) {
  // دکمه‌های فرم FRMEVALUATION — دیدن = دسترسی
  const vbf = useFormButtons('FRMEVALUATION', ["BTNNEW","BTNEDIT","BTNDELETE","BTNEVALUATIONDETAIL","BTNOK"]);
  const [data, setData]         = useState([]);
  const pg = usePager();
  const [search, setSearch]     = useState('');
  const [selected, setSelected] = useState(null);
  const [loading, setLoading]   = useState(false);
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState(EMPTY());
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');
  const [toast, setToast]       = useState('');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };

  const cols = ['عنوان', 'توضیحات', 'تعداد'];
  const initW = [320, 420, 90];
  const [colW, setColW] = useState(initW);
  const colWRef = useRef(initW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const load = useCallback(async (sr = search, page = 1) => {
    setLoading(true); setError(''); if (page === 1) setSelected(null);
    const j = await API(`/items/?search=${encodeURIComponent(sr)}&page=${page}`);
    setLoading(false);
    if (j.ok) setData(prev => pg.merge(prev, j, page)); else setError(j.msg);
  }, [search, pg]);

  useEffect(() => { load(''); }, []);   // eslint-disable-line

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm(EMPTY()); setError(''); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({ title: selected.title, remark: selected.remark });
    setError(''); setModal('edit');
  };
  const openDel = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const save = async () => {
    setSaving(true); setError('');
    const body = JSON.stringify(form);
    const j = modal === 'new'
      ? await API('/items/create/', { method: 'POST', body })
      : await API(`/items/${selected.id}/update/`, { method: 'PUT', body });
    setSaving(false);
    if (j.ok) { setModal(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/items/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); showToast('حذف شد'); load(); }
    else { setError(j.msg); setModal(null); }
  };

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
        {vbf.can('BTNEVALUATIONDETAIL') && <button onClick={() => selected && setModal('details')} disabled={!selected}
          style={{ ...ui.btnItems, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>⭐ اقلام</button>}
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && load(search)}
        style={{ ...ui.searchInput, flex: 1, minWidth: '180px' }} placeholder="جستجو (عنوان یا توضیحات)..." />
      {loading && <span>⏳</span>}
      <CountBadge shown={data.length} total={pg.total} loading={loading} />
      <ExcelButton title="انواع رسیدگی" rows={data} columns={[
        { key: 'title',  label: 'عنوان' },
        { key: 'remark', label: 'توضیحات' },
        { key: 'detail_count', label: 'تعداد اقلام', num: true },
      ]} />
    </>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack} title="اقلام رسیدگی" subtitle="بخش رسیدگی — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''}
        pager={pg} loading={loading} onMore={p => load(search, p)}>
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((h, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf3e3';   // Bisque
              const tc  = sel ? '#fff' : '#111';
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                  onClick={() => setSelected(sel ? null : r)}
                  onDoubleClick={() => { setSelected(r); setTimeout(() => setModal('details'), 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  <td style={{ ...ui.td, textAlign: 'right', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.title}>{r.title}</td>
                  <td style={{ ...ui.td, textAlign: 'right', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.remark}>{r.remark || '•'}</td>
                  <td style={{ ...ui.tdNum, color: tc }}>{toFa(r.detail_count)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 نوع رسیدگی یافت نشد</div>}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '620px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ نوع رسیدگی جدید' : '✎ ویرایش نوع رسیدگی'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>عنوان</label>
                  <input value={form.title} onChange={e => F('title', e.target.value)} style={ui.input} />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>توضیحات</label>
                  <textarea value={form.remark} onChange={e => F('remark', e.target.value)} rows={3}
                    style={{ ...ui.input, resize: 'vertical', fontFamily: 'inherit' }} />
                </div>
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'details' && selected && (
        <DetailsModal ev={selected} onClose={() => setModal(null)} onChanged={() => load()} />
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '440px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px' }}>
              <div style={{ fontSize: '34px', marginBottom: '10px' }}>🗑️</div>
              {selected?.title}
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
